
<div class="toolbar" [style]="toolbarStyle">
  <ng-content select="[trg-editor-toolbar]"></ng-content>
</div>
<div class="content {{contentClass()}}" [style]="contentStyle">
  <ng-content></ng-content>
</div>
